import { ClickButtonInstruction } from '../ClickButtonInstruction'

export class ClickPlaceOrderInstruction extends ClickButtonInstruction {
  constructor ({ waitForNoLoaders, isVisible }) {
    super({
      name: 'ClickPlaceOrder',
      waitForNoLoaders: waitForNoLoaders === undefined ? true : waitForNoLoaders,
      className: 'action primary checkout',
      click: true,
      isVisible
    })
  }
}
